import React from 'react';

interface SidebarProps {
  currentView: 'dashboard' | 'quotations' | 'detail' | 'analytics' | 'settings' | 'ai-assistant' | 'user-management';
  onNavigate: (view: 'dashboard' | 'quotations' | 'analytics' | 'settings' | 'ai-assistant' | 'user-management') => void;
}

const Sidebar: React.FC<SidebarProps> = ({ currentView, onNavigate }) => {
  return (
    <div className="w-64 bg-white shadow-sm border-r border-gray-200 fixed h-full">
      <div className="p-6 h-full flex flex-col">
        {/* Logo */}
        <div className="flex items-center space-x-3 mb-8">
          <div className="w-10 h-10 bg-primary-600 rounded-lg flex items-center justify-center">
            <span className="text-white font-bold text-xl">AI</span>
          </div>
          <div>
            <h2 className="text-lg font-bold text-gray-900">AI-QMS</h2>
            <p className="text-xs text-gray-500">Quotation Management</p>
          </div>
        </div>

        {/* Navigation */}
        <nav className="space-y-2 flex-1">
          <button
            onClick={() => onNavigate('dashboard')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-left transition-colors ${
              currentView === 'dashboard'
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl">🏠</span>
            <span>Dashboard</span>
          </button>
          
          <button
            onClick={() => onNavigate('quotations')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-left transition-colors ${
              currentView === 'quotations'
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl">📊</span>
            <span>Quotations</span>
          </button>

          <button 
            onClick={() => onNavigate('analytics')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-left transition-colors ${
              currentView === 'analytics'
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl">📈</span>
            <span>Analytics</span>
          </button>

          <button 
            onClick={() => onNavigate('settings')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-left transition-colors ${
              currentView === 'settings'
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl">⚙️</span>
            <span>Settings</span>
          </button>

          <button 
            onClick={() => onNavigate('user-management')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-left transition-colors ${
              currentView === 'user-management'
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl">👥</span>
            <span>User Management</span>
          </button>

          <button 
            onClick={() => onNavigate('ai-assistant')}
            className={`w-full flex items-center space-x-3 px-4 py-3 rounded-lg font-medium text-left transition-colors ${
              currentView === 'ai-assistant'
                ? 'bg-primary-50 text-primary-700'
                : 'text-gray-700 hover:bg-gray-100'
            }`}
          >
            <span className="text-xl">🤖</span>
            <span>AI Assistant</span>
          </button>
        </nav>

        {/* Quick Stats */}
        <div className="mt-8 p-4 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg text-white">
          <p className="text-sm font-medium mb-2">AI Processing</p>
          <p className="text-2xl font-bold">156</p>
          <p className="text-xs opacity-90 mt-1">Quotations processed today</p>
        </div>

        {/* User Info */}
        <div className="mt-6 pt-6 border-t border-gray-200">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
              <span className="text-gray-600 font-semibold">U</span>
            </div>
            <div className="flex-1">
              <p className="text-sm font-medium text-gray-900">Admin User</p>
              <p className="text-xs text-gray-500">admin@example.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
